// @flow
import { connect } from 'react-redux';
import { fetchAllLogsRequest } from 'redux/Machine/actions';
import { allLogs, alertLogs } from 'redux/Machine/selectors';
import { getUserName, getUsersLotNumber } from 'redux/User/selectors';
import { cardLogsUpdateRequest } from 'redux/Card/actions';
import { pendingStatusSelector } from 'redux/PendingStatus/selectors';
import Guard from './GuardDashboard.component';
import type { DispatchPropsType, StatePropsType } from './GuardDashboard.component';

const mapStateToProps = (state: StoreType): StatePropsType => ({
  logs: allLogs(state),
  alertLogs: alertLogs(state),
  lotNumber: getUsersLotNumber(state),
  userName: getUserName(state),
  isPending: pendingStatusSelector(state, 'guardAction'),
});

const mapDispatchToProps = (dispatch: Function): DispatchPropsType => ({
  fetchAllLogsRequest: (logType, lotNumber) => dispatch(fetchAllLogsRequest(logType, lotNumber)),
  guardActionRequest: (id, action, lotNumber) => dispatch(cardLogsUpdateRequest(id, action, lotNumber)),
});

export default (connect(mapStateToProps, mapDispatchToProps)(Guard): any);
